import { Box, Link, styled } from "@chakra-ui/react";

export const Page = styled(Box, {
	baseStyle: {
		maxWidth: 1100,
		minWidth: 700,
		width: "100%",
		flex: 1,
		background: "white",
		marginTop: 25,
		marginBottom: 25,
		marginLeft: "auto",
		marginRight: "auto",
		padding: 15,
		overflow: "hidden",
		borderRadius: "4px",
		boxShadow: "1px 2px 9px 1px gainsboro"
	}
});

export const TabPage = styled(Page, {
	baseStyle: {
		maxWidth: "unset",
		minHeight: "500px",
		marginTop: "1px",
		borderTopLeftRadius: "0"
	}
});

/** A main page single card, wrapping actions for login, password reset, etc */
export const MainPageCard = styled(Box, {
	baseStyle: {
		maxWidth: 600,
		width: "100%",
		flex: 1,
		background: "white",
		marginTop: 25,
		marginBottom: 25,
		marginLeft: "auto",
		marginRight: "auto",
		padding: "40px 20px",
		overflow: "hidden",
		borderRadius: "4px",
		boxShadow: "1px 2px 9px 1px gainsboro"
	}
});

export const TableLink = styled(Link, {
	baseStyle: {
		textDecoration: "underline",
		lineHeight: "17px",
		color: "orange.600"
	}
});
